const endpoints = {
	getProjectChatRooms: '/chats/getProjectChatRooms',
	getRoomMessages: '/chats/getRoomMessages',
	sendRoomMessage: '/chats/sendRoomMessage',
}
export {endpoints}